<template>
  <q-error-cat />
</template>

<script lang="ts" setup>
import QErrorCat from './components/QErrorCat.vue'
</script>

<style src="@klausapp/ui-kit/styles/variables.css"></style>

<style src="@klausapp/ui-kit/styles/global.css"></style>
